import type { HelpFile } from '../../types/help'
import { AccessGovernanceTestIds } from '../../../testids/AccessGovernanceTestIds'

export const accessGovernanceHelp: HelpFile = {
  docPage: '/docs/governance/overview',
  texts: {
    [AccessGovernanceTestIds.accessGovernanceWelcomeCard]:
      'Access Governance landing page — pick a tool from the sidebar: access profiles, auto-assign rules, restriction rules, requests, approval policies, certification campaigns, and delegations.',
  },
}
